import React, { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api, fmtNum, fmtDate, errMsg } from "@finance/lib/api";
import Layout, { PageHeader } from "@finance/components/Layout";

const PILL = { pending: "bg-amber-100 text-amber-700", confirmed: "bg-emerald-100 text-emerald-700", queried: "bg-red-100 text-red-700" };

export default function CashConfirm() {
  const [d, setD] = useState({ rows: [], counts: {}, can_confirm: false });
  const [st, setSt] = useState("pending");
  const load = useCallback(() => api.get("/cash-register/confirmations", { params: st ? { status: st } : {} }).then((r) => setD(r.data)), [st]);
  useEffect(() => { load(); }, [load]);
  const act = async (r, action) => {
    const reason = action === "query" ? window.prompt("What needs explaining?") : null;
    if (action === "query" && !reason) return;
    try { await api.post(`/cash-register/confirmations/${r.entry_id}`, { action, reason }); toast.success(action === "confirm" ? "Confirmed" : "Queried"); load(); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Layout>
      <PageHeader title="Cash Register Confirmation" subtitle="Cash postings by Finance post immediately and wait here for Ronick to Confirm or Query. Ronick's own postings are auto-confirmed." />
      <div className="p-4 md:p-8" data-testid="cash-confirm-page">
        <div className="mb-3 flex gap-1.5">{[["pending", "Pending confirmation"], ["confirmed", "Confirmed"], ["queried", "Queried"], ["", "All"]].map(([v, l]) => (
          <button key={v || "all"} data-testid={`cash-tab-${v || "all"}`} onClick={() => setSt(v)} className={`rounded-full border px-3 py-1 text-xs ${st === v ? "border-[#1B4383] bg-[#1B4383] text-white" : ""}`}>{l}{v && ` (${d.counts?.[v] || 0})`}</button>))}</div>
        <div className="overflow-x-auto rounded-sm border border-gray-200 bg-white">
          <table className="w-full text-sm" data-testid="cash-confirm-table">
            <thead className="bg-gray-50"><tr className="lx-label border-b text-gray-400">{["Date", "Memo", "Amount (TZS)", "Posted by", "Status", ""].map((h) => <th key={h} className="px-3 py-2 text-left">{h}</th>)}</tr></thead>
            <tbody>
              {d.rows.length === 0 && <tr><td colSpan={6} className="px-3 py-6 text-center text-xs text-gray-400">Nothing here</td></tr>}
              {d.rows.map((r) => (
                <tr key={r.entry_id} className="border-b border-gray-50" data-testid={`cash-row-${r.entry_id}`}>
                  <td className="px-3 py-2 lx-num">{fmtDate(r.date)}</td><td className="px-3 py-2">{r.memo}</td>
                  <td className={`px-3 py-2 text-right lx-num ${r.amount < 0 ? "text-red-600" : ""}`}>{fmtNum(r.amount)}</td><td className="px-3 py-2">{r.posted_by}</td>
                  <td className="px-3 py-2"><span className={`rounded-full px-2 py-0.5 text-[10px] font-semibold ${PILL[r.status]}`} title={r.reason || ""}>{r.status.toUpperCase()}</span>{r.reason && <div className="text-[10px] text-gray-400">{r.reason}</div>}</td>
                  <td className="px-3 py-2 text-right">{d.can_confirm && r.status !== "confirmed" && <span className="flex justify-end gap-2 text-xs font-semibold">
                    <button className="text-emerald-700" data-testid={`cash-confirm-${r.entry_id}`} onClick={() => act(r, "confirm")}>Confirm</button>
                    {r.status === "pending" && <button className="text-red-600" data-testid={`cash-query-${r.entry_id}`} onClick={() => act(r, "query")}>Query</button>}</span>}</td>
                </tr>))}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}
